/**
 * Cache-busting stamp for files served straight out of `public/`.
 *
 * Vite fingerprints everything it bundles, but brand and promotion images are
 * referenced by their literal path, so Cloudflare and browsers keep serving an
 * old copy for up to 30 days after the file is replaced. Appending a version
 * changes the URL, which retires the cached copy immediately.
 *
 * Bump this whenever an image under `public/images` is replaced in place.
 */
export const ASSET_VERSION = '20260804';

/** Append the current asset version to a `public/` path. */
export function versioned(path: string): string {
    return `${path}${path.includes('?') ? '&' : '?'}v=${ASSET_VERSION}`;
}
